import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import App from "./App";
import { ContextProvider } from "./contexts/ContextProvider";
import { GoogleOAuthProvider } from "@react-oauth/google";

ReactDOM.render(
  <GoogleOAuthProvider clientId="659080974027-0admdhavffv1454brkqljuekim654ihl.apps.googleusercontent.com">
    <React.StrictMode>
      <ContextProvider>
        <App />
      </ContextProvider>
    </React.StrictMode>
    ,
  </GoogleOAuthProvider>,
  document.getElementById("root")
);
